module.exports = __webpack_public_path__ + "img/logo3.e9fd7df1.png";